<template>
  <layout :show-profile="true">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 pt-12">
      <div class="flex flex-col">
        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
          <!-- Page Header: start -->
          <div class="md:flex md:items-center md:justify-between">
            <div class="flex-1 min-w-0">
              <h2 class="
                  text-2xl
                  font-light
                  leading-7
                  text-gray-900
                  sm:text-2xl sm:leading-9 sm:truncate
                ">
                User
              </h2>
            </div>

            <div class="mt-4 flex md:mt-0 md:ml-4">
              <span class="sm:ml-3 shadow-sm rounded-md">
                <Link :href="route('admin.users.permissions.index')" class="
                    inline-flex
                    items-center
                    px-4
                    py-2
                    border border-transparent
                    text-sm
                    font-medium
                    rounded-md
                    text-gray-500
                    bg-gray-300
                    shadow-sm
                    hover:bg-gray-400 hover:text-white
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-gray-400
                  ">User-Rechte</Link>
              </span>
            </div>


            <div class="mt-4 flex md:mt-0 md:ml-4">
              <span class="sm:ml-3 shadow-sm rounded-md">
                <Link :href="route('admin.users.create')" class="
                    inline-flex
                    items-center
                    px-4
                    py-2
                    border border-transparent
                    text-sm
                    font-medium
                    rounded-md
                    text-gray-500
                    bg-gray-300
                    shadow-sm
                    hover:bg-gray-400 hover:text-white
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-gray-400
                  ">Neuer User</Link>
              </span>
            </div>
          </div>
          <!-- Page Header: end -->

          <horizontal-divider />

          <!-- Filter: start -->
          <div class="flex flex-col sm:flex-row mb-4">
            <div class="mr-2 sm:w-7/12">
              <div class="mt-1 relative rounded-md shadow-sm">
                <div class="
                    absolute
                    inset-y-0
                    left-0
                    pl-3
                    flex
                    items-center
                    pointer-events-none
                  ">
                  <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clip-rule="evenodd" />
                  </svg>
                </div>
                <input type="search" class="
                    mt-1
                    pl-10
                    focus:ring-gray-400 focus:border-gray-400
                    block
                    w-full
                    sm:text-sm
                    border-gray-300
                    rounded-md
                  " placeholder="Suchen nach..." v-model="form.search" />
              </div>
            </div>

            <div class="sm:w-5/12 flex">
              <div class="w-10/12 sm:w-11/12 mr-2" v-if="$page.props.auth.user.is.admin">
                <select v-model="form.partner_id" class="
                    mt-1
                    block
                    w-full
                    py-2
                    px-3
                    border border-gray-300
                    bg-white
                    rounded-md
                    shadow-sm
                    focus:outline-none focus:ring-gray-400 focus:border-gray-400
                    sm:text-sm
                  ">
                  <option :value="null">Alle Partner</option>
                  <option v-for="partner in partners" :value="partner.id" :key="partner.id">
                    {{ partner.name }}
                  </option>
                </select>
              </div>

              <div class="w-2/12 sm:w-1/12 text-center mt-3">

                <button v-if="isFiltered" v-tooltip.left="'Filter zurücksetzen'" @click="reset">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-5 h-5 text-gray-500 hover:text-markencode-blue">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                </button>

                <div v-if="!isFiltered">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-5 h-5 text-gray-300">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                </div>

              </div>
            </div>
          </div>
          <!-- Filter: end -->

          <!-- List: start -->
          <div class="">

            <div class="mt-8 flow-root">
              <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                  <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                    <table class="min-w-full divide-y divide-gray-300">
                      <thead class="bg-gray-50">
                        <tr>
                          <th scope="col"
                            class=" w-3/12 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                            Partner</th>
                          <th scope="col" class="w-5/12 px-3 py-3.5 text-left text-sm font-semibold text-gray-900">User
                          </th>
                          <th scope="col" class=" w-2/12 px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                            Rolle</th>
                          <th scope="col" class=" w-1/12 px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                            Status</th>
                          <th scope="col" class=" w-1/12 relative py-3.5 pl-3 pr-4 sm:pr-6"></th>
                        </tr>
                      </thead>
                      <tbody class="divide-y divide-gray-200 bg-white">
                        <tr v-for="(user, idx) in users" :key="user.id">
                          <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                            <a :href="route('admin.users.edit', { id: user.id })">
                              <div class="flex-shrink-0">
                                <partner-logo :partner="user.partner" />
                              </div>

                            </a>
                          </td>
                          <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            <a :href="route('admin.users.edit', { id: user.id })">{{ user.name }}</a>

                            <p v-if="user?.note?.length > 0" class="text-sm leading-5 font-normal text-gray-400">
                              {{ user.note }}
                            </p>

                          </td>
                          <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">

                            <div v-if="user.full_roles" class="text-gray-400">
                              <a :href="route('admin.users.edit', { id: user.id })" class="flex items-center">
                                <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-4 h-4 mr-1 text-gray-500">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                  d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                              </svg> -->

                                {{ user.full_roles }}
                              </a>
                            </div>
                          </td>
                          <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center">

                            
                              <p 
                              v-if="!user.role_names.includes('admin')"
                              @click="toggleStatus(user)"
                              class="mt-1 w-3 h-3 rounded-full mx-auto  cursor-pointer"
                              :class="[user.status ? 'bg-markencode-green' : 'bg-markencode-red', userStatusProcessing == user.id ? 'animate-bounce' : '']"
                              ></p>
                            

                            <p v-if="user.role_names.includes('admin')"
                              v-tooltip.top="`Admins können nicht deaktiviert werden`"
                              class="w-3 h-3 rounded-full mx-auto bg-markencode-green opacity-40"></p>
                          </td>

                          <td
                            class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6 flex items-center space-x-3">

                            <svg v-if="!user.role_names.includes('admin')" @click.stop.prevent="deleteUser(user)"
                              xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                              stroke="currentColor"
                              class="mt-1 w-4 h-4 mr-1 cursor-pointer text-gray-500 hover:text-markencode-red">
                              <path stroke-linecap="round" stroke-linejoin="round"
                                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                            </svg>

                            <svg v-if="user.role_names.includes('admin')"
                              v-tooltip.top="`Admins können nicht gelöscht werden`" xmlns="http://www.w3.org/2000/svg"
                              fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                              class="mt-1 w-4 h-4 mr-1  text-gray-300 ">
                              <path stroke-linecap="round" stroke-linejoin="round"
                                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                            </svg>



                            <a class="
                                text-gray-400
                                hover:text-red-500
                                mt-1 
                                flex
                                items-center
                              " v-if="!user.role_names.includes('admin')" :href="route('admin.users.impersonate', { id: user.id })
    ">
                              <svg xmlns="http://www.w3.org/2000/svg" v-tooltip.top="`Zur Ansicht des Users wechseln`"
                                fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                class="w-4 h-4 mr-1 text-gray-500 hover:text-markencode-blue">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                  d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                              </svg>
                            </a>


                            <svg v-if="user.role_names.includes('admin')" xmlns="http://www.w3.org/2000/svg"
                              v-tooltip.top="`Es kann nicht zur Ansicht von Admins gewechselt werden`" fill="none"
                              viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                              class="w-4 h-4 mr-1 mt-1 text-gray-300">
                              <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                            </svg>

                            <a :href="route('admin.users.edit', { id: user.id })">
                              <svg class="h-6 w-6 mt-1 text-gray-400 hover:text-markencode-blue" fill="currentColor"
                                viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                  clip-rule="evenodd" />
                              </svg>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- List: end -->
        </div>
      </div>
    </div>

    <confirm-modal v-if="confirmModal.visible" :headline="confirmModal.headline" :text="confirmModal.text"
      @close="confirmModal.visible = false" @confirm="deleteUserConfirmed"></confirm-modal>
  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import HorizontalDivider from '@/Shared/HorizontalDivider';
import PartnerLogo from '@/Shared/PartnerLogo.vue';
// TODO: extract the confirmation modal to a decoupled component
import ConfirmModal from '@/Shared/ConfirmModal.vue';
import { pickBy, debounce, mapValues, some, isNotEmpty } from 'lodash';

export default {
  metaInfo: { title: 'User' },

  components: {
    Layout,
    HorizontalDivider,
    PartnerLogo,
    ConfirmModal,
  },

  props: ['filters', 'users', 'partners'],

  data() {
    return {
      confirmModal: {
        visible: false,
        itemId: null,
        headline: 'User löschen',
        text: '',
      },
      form: {
        search: this.filters.search,
        partner_id: this.filters.partner_id,
      },
      userStatusProcessing: null,
    };
  },

  computed: {
    isFiltered() {
      return some(this.form, isNotEmpty);
    },
  },

  watch: {
    form: {
      handler: debounce(function () {
        let query = pickBy(this.form);
        this.$inertia.get(
          this.route(
            'admin.users.index',
            Object.keys(query).length ? query : { remember: 'forget' }
          )
        );
      }, 250),
      deep: true,
    },
  },

  methods: {
    reset() {
      this.form = mapValues(this.form, () => null);
    },

    toggleStatus(user) {
      this.userStatusProcessing = user.id;

      this.$inertia.post(
        this.route('admin.users.toggle-status', { id: user.id }),
        {},
        {
          preserveScroll: true,
          preserveState: false,
          // onSuccess: (page) => {
          //   this.userStatusProcessing = null;
          // },
        }
      );
    },

    deleteUser(user) {
      this.confirmModal.itemId = user.id;
      this.confirmModal.text = `Soll der User ${user.name} wirklich gelöscht werden?`;
      this.confirmModal.visible = true;
    },

    deleteUserConfirmed() {
      if (!this.confirmModal.itemId) return;

      this.sending = true;

      this.$inertia.delete(
        this.route('admin.users.delete', {
          id: this.confirmModal.itemId,
        }),
        {
          preserveScroll: true,
          onSuccess: (page) => {
            this.sending = false;
            this.confirmModal.visible = false;
          },
        }
      );
    },
  },
};
</script>
